<template lang="html">
  <ul class="cw-box-list">
    <li class="" v-for="(boxSetInfo, index) in boxes" :key="index">
      <cw-box-cell
        :boxSetInfo="boxSetInfo"
        @click="selectionHandler(boxSetInfo)"
        :showProjectInfo="showProjectInfoInCells"
      />
    </li>
  </ul>
</template>

<script>
export default {
  name: 'cw-box-list',
  // share common functionality with component mixins
  mixins: [],
  props: {
    boxes: {
      type: Array,
      required: true,
    },
    selectionHandler: {
      type: Function,
      required: false,
      default: () => {},
    },
    showProjectInfoInCells: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  // variables
  data() {
    return {};
  },
  computed: {},
  components: {},
  // methods
  watch: {},
  methods: {},
};
</script>

<style lang="" scoped></style>
